import { useSetRecoilState } from 'recoil';
import { useCallback } from 'react';

import { SnackbarAtom } from 'atoms/snackbar';

/**
 * Hook to use snackbar notifications
 * @param { int|null } duration - time to show snackbar. If null - shown until close
 * @param { boolean } backdrop - whether show backdrop
 * @returns {{ errorNotification: function, successNotification: function, warningNotification: function }}
 */
export function useNotification(duration = 7000, backdrop = false) {
  const setSnackbar = useSetRecoilState(SnackbarAtom);
  const errorNotification = useCallback(
    message => {
      if (message) {
        setSnackbar({ message, severity: 'error', duration, backdrop });
      }
    },
    [setSnackbar, duration, backdrop],
  );
  const successNotification = useCallback(
    message => {
      if (message) {
        setSnackbar({ message, severity: 'success', duration, backdrop });
      }
    },
    [setSnackbar, duration, backdrop],
  );
  const warningNotification = useCallback(
    message => {
      if (message) {
        setSnackbar({ message, severity: 'warning', duration, backdrop });
      }
    },
    [setSnackbar, duration, backdrop],
  );

  return { errorNotification, successNotification, warningNotification };
}
